import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Typography, Upload } from "antd";
import React, { Fragment, useEffect, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addAssets, addAssetsType, getAssetTypes } from "../../redux/rtk/features/assets/assetsSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const { Dragger } = Upload;

const NewAssets = ({ drawer }) => {
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const id = getUserFromToken();

  const { Title } = Typography;
  const [form] = Form.useForm();
  const [assetTypeForm] = Form.useForm();
  const [expenseEntries, setExpenseEntries] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const assetstype = useSelector(state => state.asset.list);

  // console.log("assetstype", assetstype);


  useEffect(() => {
    dispatch(getAssetTypes());
  }, []);

  const handleAddAssetType = async (values) => {
    try {
      const response = await dispatch(addAssetsType(values));
      if (response.payload.message === "success") {
        toast.success("Asset Type added successfully");
        setIsModalVisible(false);
        assetTypeForm.resetFields();
        dispatch(getAssetTypes());
      } else {
        toast.error("Failed to add Asset Type");
      }
    } catch (error) {
      toast.error("Error while adding Asset Type");
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    assetTypeForm.resetFields();
  };

  const onFinish = async (values) => {
    const assetsData = {
      ...values,
      assetTypeId: values.assetTypeId,
      assetName: values.assetName,
      assetCode1: values.assetCode1,
      assetCode2: values.assetCode2,
      assetCode1Name: values.assetCode1Name,
      assetCode2Name: values.assetCode2Name,
      assetCost: values.assetCost,

    };
    // console.log("expense data>", assetsData)
    const resp = await dispatch(addAssets(assetsData));

    if (resp.payload.message === 'success') {
      setLoader(false);
      setExpenseEntries([]);
      toast.success('Expenses submitted successfully');
      setEditMode(false);
    } else {
      setLoader(false);
      toast.error('Failed to submit expenses');
    }
    form.resetFields();
  };


  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    toast.warning("Failed to add expense");
    // console.log("Failed:", errorInfo);
  };

  return (
    <Fragment bordered={false}>
      <UserPrivateComponent permission={"create-leaveApplication"}>
        <Row className="mr-top" justify={drawer ? "center" : "center"}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={drawer ? 22 : 16}
            xl={drawer ? 22 : 12}
            className="column-design border rounded card-custom"
          >
            {/* <Title level={4} className="m-2 mt-5 mb-5 text-center">
              Add Assets
            </Title> */}


            <Row align="center">
              <Col span={16}>
                <Title level={4} className="m-2 mt-5 mb-5 text-center">
                  Add Assets
                </Title>
              </Col>
              <Col span={6} className="m-2 mt-5 mb-5 " style={{ textAlign: "right" }}>
                <Button
                  icon={<PlusOutlined />}
                  size="default"
                  style={{
                    backgroundColor: "#28a745", // Green background
                    borderColor: "#28a745", // Green border
                    borderRadius: "8px",
                    fontWeight: "bold",
                    color: "#000", // White text for better contrast
                  }}
                  onClick={() => setIsModalVisible(true)}
                >
                  Asset Type
                </Button>


              </Col>
            </Row>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="basic"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 12,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Select Asset Type"
                name="assetTypeId"
                rules={[
                  {
                    required: true,
                    message: "Please select an asset type",
                  },
                ]}
              >
                <Select placeholder="Select an asset type">
                  {assetstype.map((asset) => (
                    <Select.Option key={asset.id} value={asset.id}>
                      {asset.assetsTypeName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Asset Name"
                name="assetName"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Asset Name",
                  },
                ]}
              >
                <Input placeholder="Enter Asset Name" />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Asset Code1 Name"
                name="assetCode1Name"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the Asset Code1 Name",
                //   },
                // ]}
              >
                <Input placeholder="Enter Asset Code1 Name" />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Asset Code1"
                name="assetCode1"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the Asset Code 1",
                //   },
                // ]}
              >
                <Input placeholder="Enter Asset Code 1" />
              </Form.Item>

              
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Asset Code2 Name"
                name="assetCode2Name"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the Asset Code2 Name",
                //   },
                // ]}
              >
                <Input placeholder="Enter Asset Code2 Name" />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="AssetCode2"
                name="assetCode2"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the Asset Code 2",
                //   },
                // ]}
              >
                <Input placeholder="Enter Asset Code 2 " />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Asset Cost"
                name="assetCost"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the Asset Cost",
                //   },
                // ]}
              >
                <InputNumber placeholder="Enter Asset Cost" />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{
                  offset: 6,
                  span: 12,
                }}
              >
                <Button type="primary" size="large" htmlType="submit" block>
                  {editMode ? "Update Assets" : "Add Assets"}
                </Button>
              </Form.Item>
            </Form>

          </Col>
        </Row>

        <Modal
          title="Add Asset Type"
          visible={isModalVisible}
          onCancel={handleModalCancel}
          footer={null}
        >
          <Form
            form={assetTypeForm}
            onFinish={handleAddAssetType}
            layout="vertical"
          >
            <Form.Item
              label="Asset Type Name"
              name="assetsTypeName"
              rules={[{ required: true, message: "Please enter the Asset Type Name" }]}
            >
              <Input placeholder="Enter Asset Type Name" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                onClick={handleModalCancel}
              >
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </UserPrivateComponent>
    </Fragment>
  );
};


export default NewAssets; 